import { GlobalSettingsKeys } from '../../api/models/GlobalSettingsKeys';
import { GlobalSettings } from '../../api/models/GlobalSettings';

export class PlayerUtil {
  static getInitialBitrate(globalSettings: GlobalSettings): number {
    const bitrate = 3000000;
    if (screen.height > 2000) {
      return globalSettings.numberValue(GlobalSettingsKeys.playerInitialBitrate4K) || bitrate;
    } else {
      return globalSettings.numberValue(GlobalSettingsKeys.playerInitialBitrate) || bitrate;
    }
  }
}
